// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"LoginNavButtons_mainContainer__9lpNy","content":"LoginNavButtons_content__1kYil","divider":"LoginNavButtons_divider__3fmjJ","link":"LoginNavButtons_link__2oJx_"};